export default __webpack_public_path__ + "static/media/icon-sidebar-chevron.21e6a52f.svg";